module.exports = __webpack_public_path__ + "static/img/continue.2c187c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/continue.png
// module id = gKMn
// module chunks = 1